export default __webpack_public_path__ + "static/media/InstagramLogo.c3b1c6aa.svg";